import { has } from 'lodash';
import { destandard, getPaginationFromMeta } from '../utils/commonFunctions';

export const GET_SUBMISSION_LIST_PENDING = 'GET_SUBMISSION_LIST_PENDING';
export const GET_SUBMISSION_LIST_REJECTED = 'GET_SUBMISSION_LIST_REJECTED';
export const GET_SUBMISSION_LIST_FETCHED = 'GET_SUBMISSION_LIST_FETCHED';
export const GET_USER_SUBMISSION_LIST_PENDING =
  'GET_USER_SUBMISSION_LIST_PENDING';
export const GET_USER_SUBMISSION_LIST_REJECTED =
  'GET_USER_SUBMISSION_LIST_REJECTED';
export const GET_USER_SUBMISSION_LIST_FETCHED =
  'GET_USER_SUBMISSION_LIST_FETCHED';
export const GET_USER_SUBMISSION_OVERVIEW_PENDING =
  'GET_USER_SUBMISSION_OVERVIEW_PENDING';
export const GET_USER_SUBMISSION_OVERVIEW_REJECTED =
  'GET_USER_SUBMISSION_OVERVIEW_REJECTED';
export const GET_USER_SUBMISSION_OVERVIEW_FETCHED =
  'GET_USER_SUBMISSION_OVERVIEW_FETCHED';
export const GET_SUBMISSION_PENDING = 'GET_SUBMISSION_PENDING ';
export const GET_SUBMISSION_REJECTED = 'GET_SUBMISSION_REJECTED';
export const GET_SUBMISSION_FETCHED = 'GET_SUBMISSION_FETCHED';
export const GET_SUBMISSION_META_PENDING = 'GET_SUBMISSION_META_PENDING';
export const GET_SUBMISSION_META_FULFILLED = 'GET_SUBMISSION_META_FULFILLED';
export const GET_SUBMISSION_META_REJECTED = 'GET_SUBMISSION_META_REJECTED';
export const GET_SELL_IT_OBJECTIVES_PENDING = 'GET_SELL_IT_OBJECTIVES_PENDING';
export const GET_SELL_IT_OBJECTIVES_REJECTED = 'GET_SELL_IT_OBJECTIVES_REJECTED';
export const GET_SELL_IT_OBJECTIVES_FULFILLED = 'GET_SELL_IT_OBJECTIVES_FULFILLED';
export const GET_NGP_OBJECTIVES_PENDING = 'GET_NGP_OBJECTIVES_PENDING';
export const GET_NGP_OBJECTIVES_REJECTED = 'GET_NGP_OBJECTIVES_REJECTED';
export const GET_NGP_OBJECTIVES_FULFILLED = 'GET_NGP_OBJECTIVES_FULFILLED';
export const GET_NEXT_AUDIT_SUBMISSION_PENDING = 'GET_NEXT_AUDIT_SUBMISSION_PENDING';
export const GET_NEXT_AUDIT_SUBMISSION_FULFILLED = 'GET_NEXT_AUDIT_SUBMISSION_FULFILLED';
export const GET_NEXT_AUDIT_SUBMISSION_REJECTED = 'GET_NEXT_AUDIT_SUBMISSION_REJECTED';

const initialState = {
  paging: {
    number: 1,
    size: 20,
  },
};

export default function submissions(
  state = {
    meta: {
      stores: [],
      outlet_ids: [],
      campaigns: [],
      proof_types: [],
      sell_it_objectives: [],
      'postcodeplan-objectives': []
    },
    submissions: [],
    user_submissions: [],
    user_submissions_overview: {},
    submission: {},
    next_audit_submission: {},
    fetching: false,
    fetched: false,
    errors: {},
    paging: {
      number: 1,
      size: 20
    }
  },
  action
) {
  switch (action.type) {
    case GET_SUBMISSION_LIST_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_SUBMISSION_LIST_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        submissions: action.payload.data,
        meta: action.payload.meta,
        paging: getPaginationFromMeta(initialState.paging, state.paging, action.payload.links)
      };
    }
    case GET_SUBMISSION_LIST_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_USER_SUBMISSION_LIST_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_USER_SUBMISSION_LIST_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        user_submissions: {
          ...state.user_submissions,
          [action.payload.outlet]: { submissions: action.payload.data }
        }
      };
    }
    case GET_USER_SUBMISSION_LIST_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_USER_SUBMISSION_OVERVIEW_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_USER_SUBMISSION_OVERVIEW_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        user_submissions_overview: {
          ...state.user_submissions_overview,
          [action.payload.outlet]: {
            total_submissions: action.payload.total_submissions,
            submission_breakdown: action.payload.submission_breakdown
          }
        }
      };
    }
    case GET_USER_SUBMISSION_OVERVIEW_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_SUBMISSION_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_SUBMISSION_FETCHED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        submission: action.payload.data,
        meta: destandard(action.payload.meta)
      };
    }
    case GET_SUBMISSION_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_NEXT_AUDIT_SUBMISSION_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_NEXT_AUDIT_SUBMISSION_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        next_audit_submission: action.payload.data
      };
    }
    case GET_NEXT_AUDIT_SUBMISSION_REJECTED: {
      if (has(action.payload, 'data')) {
        return {
          ...state,
          fetching: false,
          fetched: false,
          errors: action.payload.data.errors
        };
      }

      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_SUBMISSION_META_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_SUBMISSION_META_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        meta: action.payload
      };
    }
    case GET_SUBMISSION_META_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case GET_SELL_IT_OBJECTIVES_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_SELL_IT_OBJECTIVES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        sell_it_objectives: action.payload
      };
    }
    case GET_SELL_IT_OBJECTIVES_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      };
    }
    case GET_NGP_OBJECTIVES_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_NGP_OBJECTIVES_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        sell_it_objectives: action.payload
      };
    }
    case GET_NGP_OBJECTIVES_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      };
    }
    default: {
      return {...state};
    }
  }
}
